/**
 * @file 用户相关 API
 */
import qs from 'qs';
import axios from '@utils/axios';

const jsonHeaders = { 'Content-Type': 'application/json' };

/** 检查登录状态 */
export async function checkLoginApi(params?: any) {
    return axios.get(`/lbsmap/portal/user/checklogin?${qs.stringify(params)}`);
}

/** 获取用户信息 */
export async function getUserInfoApi(params?: any) {
    return axios.post(`/lbsmap/portal/user/checkuser`, params, { headers: jsonHeaders });
}

export interface AuthDetail {
    type: 'individual' | 'corporation' | string;
    name?: string;
    company_name?: string;
    [key: string]: any;
}

/** 获取认证详情 */
export async function getAuthDetailApi(): Promise<AuthDetail | null> {
    try {
        const res: any = await axios.get('/lbsapi/apiconsole/auth/getAuthDetail');
        const info = res?.info ?? null;
        if (!info || typeof info !== 'object' || Object.keys(info).length === 0) {
            return null;
        }
        return info as AuthDetail;
    } catch {
        return null;
    }
}



